import { Create, Edit, SimpleForm, TextInput, SelectInput, DateField, Filter, SearchInput, ReferenceInput } from 'react-admin';
import { useSearchParams } from 'react-router-dom';
import { Box, Alert } from '@mui/material';
import { REPRESENTATIVE_STATUS } from './constants';

export const RepresentativeCreate = () => {
  const [searchParams] = useSearchParams();
  const prefillEmployeeId = searchParams.get('employeeId') || '';

  return (
    <Create>
      <SimpleForm>
        <Alert severity="info" sx={{ mb: 2 }}>
          OHS Representative appointment per OHS Act Section 17 — all fields required for DOE records
        </Alert>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
          <ReferenceInput source="employee.id" reference="employees" fullWidth defaultValue={prefillEmployeeId}>
            <SelectInput optionText="name" label="Employee" />
          </ReferenceInput>
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
          <TextInput source="areaRepresented" label="Area Represented" fullWidth placeholder="e.g., Production Floor A, Warehouse B" />
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
          <TextInput source="electedAt" label="Date Elected / Appointed" type="date" fullWidth />
          <TextInput source="termEndDate" label="Term End Date" type="date" fullWidth helperText="Typically 12 months from election" />
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
          <SelectInput source="status" choices={REPRESENTATIVE_STATUS.map(s => ({ id: s, name: s }))} fullWidth defaultValue="PendingTraining" label="Status" />
          <SelectInput source="trainingCompleted" choices={[{ id: 'true', name: 'Yes - Completed' }, { id: 'false', name: 'No - Training Required' }]} fullWidth label="Initial Training Completed" />
        </Box>
        <TextInput source="trainingProvider" label="Training Provider" fullWidth placeholder="e.g., NOSA, SAIOH" sx={{ mb: 2 }} />
        <TextInput source="appointedBy" label="Appointed By (Manager Name)" fullWidth placeholder="e.g., Sarah van der Merwe" sx={{ mb: 2 }} />
        <TextInput source="notes" label="Additional Notes" multiline fullWidth rows={3} placeholder="Any additional information about this representative appointment..." />
      </SimpleForm>
    </Create>
  );
};

export const RepresentativeEdit = () => (
  <Edit>
    <SimpleForm>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        <ReferenceInput source="employee.id" reference="employees" fullWidth>
          <SelectInput optionText="name" label="Employee" />
        </ReferenceInput>
        <DateField source="expiryDate" label="Expiry Date" />
        <SelectInput source="status" choices={REPRESENTATIVE_STATUS.map(s => ({ id: s, name: s }))} fullWidth />
      </Box>
    </SimpleForm>
  </Edit>
);

export const RepresentativeFilters = () => (
  <Filter>
    <SearchInput source="q" placeholder="Search representative name" />
    <SelectInput source="status" choices={REPRESENTATIVE_STATUS.map(s => ({ id: s, name: s }))} alwaysOn />
  </Filter>
);
